import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {Voucher} from "../api";

export class VoucherService extends RestService<Voucher> {
    constructor(url: string) {
        url ? super(url) : super(REST_API_END_POINTS.VOUCHERS)
    }

    cancel(values) {
        return this.instance.post(`${this.url}cancel`, values)
    }

    send_voucher_details_by_email_with_pdf() {
        return this.instance.post(
            `${this.url}send_voucher_details_by_email_with_pdf`
        )
    }

    change_invoice_number(invoice_number: string) {
        return this.instance.get(`${this.url}change_invoice_number/${invoice_number}/`)
    }
}
